<template>
  <com-page>
    <com-search :columns="searchColumn" @search="handleSearch">
      <template>
        <el-button type="primary" @click="handleCreated">添加网点</el-button>
        <el-button type="primary" @click="handleExport">导出</el-button>
      </template>
    </com-search>
    <com-card>
      <SiteList ref="siteListRef"></SiteList>
    </com-card>
  </com-page>
</template>

<script>
import { exportExcel } from '@/utils/index'
import { siteListApi } from '@/api/site'
import { formatDate } from '@/filters'
import SiteList from './components/site-list'

export default {
  components: { SiteList },
  data() {
    return {
      searchColumn: [
        {
          label: '网点名称',
          prop: 'name',
          type: 'input'
        },
        {
          label: '小区名称',
          prop: 'refResidentialAreaName',
          type: 'input'
        },
        {
          label: '所在区域',
          prop: 'regionId',
          type: 'region'
        },
        {
          label: '上下架',
          prop: 'status',
          type: 'select',
          option: [
            {
              label: '上架',
              value: '1'
            },
            {
              label: '下架',
              value: '0'
            }
          ]
        }
      ],
      exportQuery: {
        pageIndex: 1,
        pageSize: 10000
      }
    }
  },
  methods: {
    handleCreated() {
      this.$router.push({ name: 'site-edit', params: { type: 'created' } })
    },
    handleSearch(val) {
      const params = {
        area: val.regionId && val.regionId.length ? val.regionId.at(-1) : '',
        ...val
      }
      if (val.regionId && val.regionId.length) {
        delete params.regionId
      }
      this.exportQuery = { pageIndex: 1, pageSize: 10000, ...params }
      this.$refs.siteListRef.search(params)
      console.log('search :>> ', params)
    },
    handleExport() {
      this.$message.info('请稍等,正在导出...')
      siteListApi(this.exportQuery).then((res) => {
        const { records } = res.data
        // eslint-disable-next-line prefer-const
        let newArr = []
        records.forEach((item) => {
          const params = {
            编号: item.number,
            网点名称: item.name,
            地址: item.address,
            区域: item.areaName,
            公司资产: item.companyAssets === "1" ? '是' : '否',
            创建时间: formatDate(item.createTime),
            创建人: item.createBy,
            生效时间: formatDate(item.effectiveTime),
            到期时间: formatDate(item.expireTime),
            网点有效年份: item.storeAge,
            已运营时间: item.operationTime,
            设备数: item.deviceCount,
            订单数: item.orderCount,
            订单金额: item.orderAmount
          }
          newArr.push(params)
        })
        exportExcel(newArr, '网点列表')
      })
    }
  },
  activated() {
    console.log('activated :>> ,', this.$route)
    if (this.$route.params) {
      const { type } = this.$route.params
      if (type === 'update') this.$refs.siteListRef.init()
    }
    // this.$refs.siteListRef.init()
  }
}
</script>
